export default "__VITE_ASSET__4be2712a__"